import { ReactNode } from "react";

import HelpTooltip from "@/components/ui/HelpTooltip";

interface Props {
  title: string;
  description?: string;
  helpTooltip?: string;
  actions?: ReactNode;
  children: ReactNode;
}

/** Plain card wrapper for an EnterpriseIdentity settings section. */
export const SectionShell = ({ title, description, helpTooltip, actions, children }: Props) => (
  <section className="rounded-lg border border-gray-200 bg-white p-6">
    <div className="mb-4 flex flex-wrap items-start justify-between gap-2">
      <div>
        <h3 className="flex items-center text-base font-semibold text-gray-900">
          {title}
          {helpTooltip && <HelpTooltip content={helpTooltip} />}
        </h3>
        {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
    <div className="space-y-4">{children}</div>
  </section>
);
